import I18n from 'i18n'
import { takeLatest, call, put } from 'redux-saga/effects'

import UploadFile from 'api/commons/UploadFile'
import { ErrorToast } from 'components/ui/toast/toastsTemplates'
import { ActionWithPayload } from 'helpers/redux-actions.helper'
import externalCourseParticipantsList, {
  GetListResponse,
} from 'api/administration/externalCourseParticipants/GetList'
import {
  EXTERNAL_COURSE_UPLOAD_CERTIFICATE,
  PayloadUploadCertificatesExternalCourse,
  Actions,
} from '../../actions/externalCourses.action'
import { Actions as ParticipantActions } from '../../actions/externalCourseParticipant.action'
const uploadCertificatesExternalCourses = ({
  id,
  file,
}: PayloadUploadCertificatesExternalCourse) => {
  return UploadFile(
    file,
    `/administration/external_courses/${id}/external_course_certificate`
  )
}

const pattern = EXTERNAL_COURSE_UPLOAD_CERTIFICATE

export type DestroyExternalCoursesAction = ActionWithPayload<
  typeof pattern,
  PayloadUploadCertificatesExternalCourse
>

function* uploadCertificatesExternalCourseEffectSaga(
  action: DestroyExternalCoursesAction
) {
  try {
    const { id, file, participantList } = action.payload
    const { data } = yield call(uploadCertificatesExternalCourses, { id, file })
    if (participantList) {
      const { externalCourseId, params, callback } = participantList
      if (externalCourseId) {
        const resList: GetListResponse = yield call(
          externalCourseParticipantsList,
          externalCourseId,
          params
        )
        callback && callback(resList)
        const { data, total, perPage: resPerPage } = resList
        yield put(
          ParticipantActions.setAdministrationListSuccess(
            data,
            total,
            resPerPage,
            params?.sort
          )
        )
      }
    }
    yield put(Actions.uploadCertificatesSuccess(data))
    yield put(
      Actions.getList({
        page: 1,
        searchText: '',
      })
    )
  } catch (error) {
    ErrorToast(I18n.t('administration.toastMessages.deleteError'))
    console.log('error: ', error)
  }
}

export function* uploadCertificatesExternalCoursesWatcherSaga() {
  yield takeLatest(pattern, uploadCertificatesExternalCourseEffectSaga)
}
